/* @flow */

import { linkActionMaker } from '@website/components/ActionMakers'
import { addLink } from '@website/components/CommonActions'

export default dispatcher => ({
  addLink: idx => dispatcher(addLink(idx)),
  linkActions: linkActionMaker(dispatcher)
})
